(function (h) {
    if (h.__locPatch) return;
    const P = h.pushState,
        R = h.replaceState,
        fire = () => window.dispatchEvent(new Event("locationchange"));
    h.pushState = function () {
        const r = P.apply(this, arguments);
        fire();
        return r;
    };
    h.replaceState = function () {
        const r = R.apply(this, arguments);
        fire();
        return r;
    };
    window.addEventListener("popstate", fire);
    h.__locPatch = true;
})(window.history);

function Comp18() {
    $(document)
        .off("click.comp18")
        .on(
            "click.comp18",
            ".comp-18.compCollapse .compCollapse-toggle .btn, .compCollapse-close .btn",
            function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(this).closest(".comp-18.compCollapse").toggleClass("show");
            }
        );

    const closeAll = () => $(".comp-18.compCollapse").removeClass("show");

    $(window)
        .off(".comp18")
        .on("hashchange.comp18 locationchange.comp18", closeAll);
}
Comp18();
